import { GET_MAIL_LIST, CREATE_Mail } from '../config/api-url';
import { getRequest, postRequest } from '../config/auth';

export const getAllMailListAPI = (data) => getRequest(`${GET_MAIL_LIST}`, data);
export const createMailAPI = (data) => postRequest(`${CREATE_Mail}`, data);
